module.exports = __webpack_public_path__ + "img/informa_logo.7c316492.png";